module.exports = __webpack_public_path__ + "static/img/znbx_pic1.3.f28fa1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/Insurance/znbx_pic1.3.jpg
// module id = 2Dp9
// module chunks = 0